import * as React from "react";
import { Checkbox } from "semantic-ui-react";
import styles from "./ToggleField.module.scss";
export type NumberFieldProps = {
  labels: { left: string; right: string };
  checked: boolean;

  disabled?: boolean;
  onClick: () => void;
  id: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ToggleField({
  labels,
  checked,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  disabled = false,
  onClick,
  id
}: NumberFieldProps): JSX.Element {
  return (
    <div id={id} className={styles.ToggleField}>
      <span className={checked ? null : styles.Selected}>{labels.left}</span>
      <>
        <Checkbox
          toggle={true}
          //   label="Input/Output"
          checked={checked}
          onClick={() => onClick()}
        />
      </>
      <span className={checked ? styles.Selected : null}>{labels.right}</span>
    </div>
  );
}

export default ToggleField;
